/**
 * @description 格式化时间
 * @param time
 * @param cFormat
 * @returns {string|null}
 */
export function parseTime(time, cFormat) {
  if (arguments.length === 0) {
    return null
  }
  const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
  let date
  if (typeof time === 'object') {
    date = time
  } else {
    if (typeof time === 'string' && /^[0-9]+$/.test(time)) {
      time = parseInt(time)
    }
    if (typeof time === 'number' && time.toString().length === 10) {
      time = time * 1000
    }
    date = new Date(time)
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  }
  return format.replace(/{([ymdhisa])+}/g, (result, key) => {
    let value = formatObj[key]
    if (key === 'a') {
      return ['日', '一', '二', '三', '四', '五', '六'][value]
    }
    if (result.length > 0 && value < 10) {
      value = '0' + value
    }
    return value || 0
  })
}

/**
 * @description 格式化时间
 * @param time
 * @param option
 * @returns {string}
 */
export function formatTime(time, option) {
  if (('' + time).length === 10) {
    time = parseInt(time) * 1000
  } else {
    time = +time
  }
  const d = new Date(time)
  const now = Date.now()

  const diff = (now - d) / 1000

  if (diff < 30) {
    return '刚刚'
  } else if (diff < 3600) {
    // less 1 hour
    return Math.ceil(diff / 60) + '分钟前'
  } else if (diff < 3600 * 24) {
    return Math.ceil(diff / 3600) + '小时前'
  } else if (diff < 3600 * 24 * 2) {
    return '1天前'
  }
  if (option) {
    return parseTime(time, option)
  } else {
    return (
      d.getMonth() +
      1 +
      '月' +
      d.getDate() +
      '日' +
      d.getHours() +
      '时' +
      d.getMinutes() +
      '分'
    )
  }
}

/**
 * @description 将url请求参数转为json格式
 * @param url
 * @returns {{}|any}
 */
export function paramObj(url) {
  const search = url.split('?')[1]
  if (!search) {
    return {}
  }
  return JSON.parse(
    '{"' +
      decodeURIComponent(search)
        .replace(/"/g, '\\"')
        .replace(/&/g, '","')
        .replace(/=/g, '":"')
        .replace(/\+/g, ' ') +
      '"}'
  )
}

/**
 * @description 父子关系的数组转换成树形结构数据
 * @param data
 * @returns {*}
 */
export function translateDataToTree(data) {
  const parent = data.filter(
    (value) => value.parentId === 'undefined' || value.parentId === null
  )
  const children = data.filter(
    (value) => value.parentId !== 'undefined' && value.parentId !== null
  )
  const translator = (parent, children) => {
    parent.forEach((parent) => {
      children.forEach((current, index) => {
        if (current.parentId === parent.id) {
          const temp = JSON.parse(JSON.stringify(children))
          temp.splice(index, 1)
          translator([current], temp)
          typeof parent.children !== 'undefined'
            ? parent.children.push(current)
            : (parent.children = [current])
        }
      })
    })
  }
  translator(parent, children)
  return parent
}

/**
 * @description 树形结构数据转换成父子关系的数组
 * @param data
 * @returns {[]}
 */
export function translateTreeToData(data) {
  const result = []
  data.forEach((item) => {
    const loop = (data) => {
      result.push({
        id: data.id,
        name: data.name,
        parentId: data.parentId,
      })
      const child = data.children
      if (child) {
        for (let i = 0; i < child.length; i++) {
          loop(child[i])
        }
      }
    }
    loop(item)
  })
  return result
}

/**
 * @description 10位时间戳转换
 * @param time
 * @returns {string}
 */
export function tenBitTimestamp(time) {
  const date = new Date(time * 1000)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '' + m : m
  let d = date.getDate()
  d = d < 10 ? '' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second //组合
}

/**
 * @description 13位时间戳转换
 * @param time
 * @returns {string}
 */
export function thirteenBitTimestamp(time) {
  const date = new Date(time / 1)
  const y = date.getFullYear()
  let m = date.getMonth() + 1
  m = m < 10 ? '' + m : m
  let d = date.getDate()
  d = d < 10 ? '' + d : d
  let h = date.getHours()
  h = h < 10 ? '0' + h : h
  let minute = date.getMinutes()
  let second = date.getSeconds()
  minute = minute < 10 ? '0' + minute : minute
  second = second < 10 ? '0' + second : second
  return y + '年' + m + '月' + d + '日 ' + h + ':' + minute + ':' + second //组合
}

/**
 * @description 获取随机id
 * @param length
 * @returns {string}
 */
export function uuid(length = 32) {
  const num = 'abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ1234567890'
  let str = ''
  for (let i = 0; i < length; i++) {
    str += num.charAt(Math.floor(Math.random() * num.length))
  }
  return str
}

/**
 * @description m到n的随机数
 * @param m
 * @param n
 * @returns {number}
 */
export function random(m, n) {
  return Math.floor(Math.random() * (m - n) + n)
}

/**
 * @description addEventListener
 * @type {function(...[*]=)}
 */
export const on = (function () {
  return function (element, event, handler, useCapture = false) {
    if (element && event && handler) {
      element.addEventListener(event, handler, useCapture)
    }
  }
})()

/**
 * @description removeEventListener
 * @type {function(...[*]=)}
 */
export const off = (function () {
  return function (element, event, handler, useCapture = false) {
    if (element && event) {
      element.removeEventListener(event, handler, useCapture)
    }
  }
})()

/**
 * @description 数组打乱
 * @param array
 * @returns {*}
 */
export function shuffle(array) {
  let m = array.length,
    t,
    i
  while (m) {
    i = Math.floor(Math.random() * m--)
    t = array[m]
    array[m] = array[i]
    array[i] = t
  }
  return array
}

// 首字母大小
export function titleCase(str) {
  return str.replace(/( |^)[a-z]/g, (L) => L.toUpperCase())
}

// 下划转驼峰
export function camelCase(str) {
  return str.replace(/-[a-z]/g, (str1) => str1.substr(-1).toUpperCase())
}

export function isNumberStr(str) {
  return /^[+-]?(0|([1-9]\d*))(\.\d+)?$/g.test(str)
}

// 限制只能输入价格 small小数点后显示几位，默认2位，-1等于不限制
// el-input @input.native="v-model=$common.checkInputPrice($event)"
export function checkInputPrice(event, small = 2, type) {
  if (type == '<zero') {
    let that = event.target
    that.value = that.value.replace(/[^\-\d.]/g, '') //第一个字符不能是.
    that.value = that.value.replace(/^\./g, '') //第一个字符不能是.
    that.value = that.value.replace(/\.{2,}/g, '.') // 不能连续输入.
    that.value = that.value.replace(/(\.\d+)\./g, '$1') // .后面不能再输入.
    that.value = that.value.replace(/(-)\./g, '$1') // -后面不能输入.
    that.value = that.value.replace(/\-{2,}/g, '-') // -只能保留一个
    that.value = that.value.replace(/(\d+|\.)-/g, '$1') // 数字和.后面不能接-,不能出现类似11-, 12.-
    that.value = that.value.replace(/-(0){2,}/g, '$1') // 不能出现-00,-001,-0001类似
    that.value = that.value.replace(/(-)0+(\d+)/g, '$1$2') // 不能出现-01,-02类似
    that.value = that.value.replace(/^0+(\d)/, '$1') // 第一位0开头，0后面为数字，则过滤掉，取后面的数字
    that.value = that.value.replace(/(\d{15})\d*/, '$1') // 最多保留15位整数
    that.value = that.value.replace(/(\.\d{2})\d*/, '$1') // 最多保留2位小数

    return that.value
  } else {
    let that = event.target
    that.value = that.value.replace(/。/g, '.') // 中文句号换成英文点
    // that.value = that.value.replace(/^0*/g, '');  // 第一个数不能为0 ，若为0替换为空
    that.value = that.value.replace(/[^\d.]/g, '') // 是否是数字 和小数点，若是除数字 和小数点之外的则替换为空
    that.value = that.value.replace(/^\./g, '') // 确证第一个为数字而不是“.”
    that.value = that.value.replace(/\.{2,}/g, '.') // 只能输入一个“.”
    that.value = that.value
      .replace('.', '$#$')
      .replace(/\./g, '')
      .replace('$#$', '.') // 保证“.”只出现一次，而不能出现两次以上
    if (small == 1) {
      that.value = that.value.replace(/^(\-)*(\d+)\.(\d).*$/, '$1$2.$3') // 只能输入1个小数
    } else if (small == 2) {
      that.value = that.value.replace(/^(\-)*(\d+)\.(\d\d).*$/, '$1$2.$3') // 只能输入两个小数
    } else if (small == 3) {
      that.value = that.value.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, '$1$2.$3') // 只能输入三个小数
    }
    return that.value
  }
}

// export function smalltoBIG(num) {
//   const fraction = ['角', '分']
//   const digit = ['零', '壹', '贰', '叁', '肆', '伍', '陆', '柒', '捌', '玖']
//   const unit = [
//     ['元', '万', '亿'],
//     ['', '拾', '百', '千'],
//   ]
//   let head = num < 0 ? '欠' : ''
//   num = Math.abs(num)
//   let s = ''

//   fraction.forEach((item, index) => {
//     s += (
//       digit[Math.floor(num * 10 * Math.pow(10, index)) % 10] + item
//     ).replace(/零./, '')
//   })
//   s = s || '整'
//   num = Math.floor(num)

//   for (let i = 0; i < unit[0].length && num > 0; i++) {
//     let p = ''
//     for (let j = 0; j < unit[1].length && num > 0; j++) {
//       p = digit[num % 10] + unit[1][j] + p
//       num = Math.floor(num / 10)
//     }
//     s = p.replace(/(零.)*零$/, '').replace(/^$/, '零') + unit[0][i] + s
//   }
//   return (
//     head +
//     s
//       .replace(/(零.)*零元/, '元')
//       .replace(/(零.)+/g, '零')
//       .replace(/^整$/, '零元整')
//   )
// }
// ...existing code...
export function smalltoBIG(currencyDigits) {
  // 支持到 '垓'（10^20）级别，根据需要可继续扩展 bigRadices
  var CN_ZERO = '零'
  var CN_ONE = '壹'
  var CN_TWO = '贰'
  var CN_THREE = '叁'
  var CN_FOUR = '肆'
  var CN_FIVE = '伍'
  var CN_SIX = '陆'
  var CN_SEVEN = '柒'
  var CN_EIGHT = '捌'
  var CN_NINE = '玖'
  var CN_TEN = '拾'
  var CN_HUNDRED = '佰'
  var CN_THOUSAND = '仟'
  var CN_TEN_THOUSAND = '万'
  var CN_HUNDRED_MILLION = '亿'
  var CN_TRILLION = '兆'
  var CN_PETRA = '京'
  var CN_EXA = '垓'
  var CN_DOLLAR = '元'
  var CN_TEN_CENT = '角'
  var CN_CENT = '分'
  var CN_INTEGER = '整'

  // Normalize input
  currencyDigits =
    currencyDigits === 0 || currencyDigits === '0'
      ? '0'
      : (currencyDigits || '').toString()
  if (currencyDigits.trim() === '') return ''

  // 去除千分位逗号、前导空格和前导0（但保留单个0）
  currencyDigits = currencyDigits.replace(/,/g, '').replace(/^\s+|\s+$/g, '')
  currencyDigits = currencyDigits.replace(/^0+(\d)/, '$1')
  // 分离整数和小数
  var parts = currencyDigits.split('.')
  var integral = parts[0] || ''
  var decimal = parts[1] || ''

  // 限制整数长度：每4位一个大单位，本实现支持到 bigRadices.length*4 位
  var bigRadices = [
    '',
    CN_TEN_THOUSAND,
    CN_HUNDRED_MILLION,
    CN_TRILLION,
    CN_PETRA,
    CN_EXA,
  ]
  var maxIntLen = bigRadices.length * 4
  if (integral.length > maxIntLen) {
    console.error('金额过大，应小于 ' + maxIntLen + ' 位整数！')
    return ''
  }

  // 处理小数，只保留两位
  if (decimal.length > 2) decimal = decimal.substr(0, 2)

  // 准备字符表
  var digits = [
    CN_ZERO,
    CN_ONE,
    CN_TWO,
    CN_THREE,
    CN_FOUR,
    CN_FIVE,
    CN_SIX,
    CN_SEVEN,
    CN_EIGHT,
    CN_NINE,
  ]
  var radices = ['', CN_TEN, CN_HUNDRED, CN_THOUSAND]
  var outputCharacters = ''

  // 处理整数部分：从右向左每4位为一组
  if (Number(integral) > 0) {
    var zeroCount = 0
    var intLen = integral.length
    // 按组处理
    var groupCount = Math.ceil(intLen / 4)
    for (var i = 0; i < groupCount; i++) {
      var groupIndexFromRight = i // 0 表示最低位组
      var groupStr = ''
      // 处理当前组内的四位，从低位到高位
      for (var j = 0; j < 4; j++) {
        // 计算当前数字在整数字符串中的位置
        var pos = intLen - (i * 4 + j) - 1
        if (pos < 0) break
        var digit = integral.charAt(pos)
        if (digit === '0') {
          zeroCount++
        } else {
          if (zeroCount > 0) {
            groupStr = digits[0] + groupStr
          }
          zeroCount = 0
          groupStr = digits[Number(digit)] + radices[j] + groupStr
        }
      }
      if (groupStr !== '') {
        groupStr = groupStr + bigRadices[groupIndexFromRight]
      }
      outputCharacters = groupStr + outputCharacters
    }
    outputCharacters += CN_DOLLAR
  }

  // 处理小数部分
  if (decimal !== '') {
    for (var k = 0; k < decimal.length; k++) {
      var d = decimal.charAt(k)
      if (d !== '0') {
        outputCharacters +=
          digits[Number(d)] + (k === 0 ? CN_TEN_CENT : CN_CENT)
      }
    }
  }

  // 为空时补充零元
  if (outputCharacters === '') {
    outputCharacters = CN_ZERO + CN_DOLLAR
  }
  // 若无小数则末尾加整
  if (decimal === '') {
    outputCharacters += CN_INTEGER
  }
  // 清理连续零等冗余字符（尽量模仿常见格式）
  outputCharacters = outputCharacters
    .replace(/零(仟|佰|拾)/g, '零')
    .replace(/(零)+/g, '零')
    .replace(/零(万|亿|兆|京|垓)/g, '$1')
    .replace(/(万)+(?=亿)/g, '万')
    .replace(/亿万/g, '亿')
    .replace(/^整$/, CN_ZERO + CN_DOLLAR + CN_INTEGER)

  return outputCharacters
}
// 限制只能输入数字
export function checkInputNum(event, type) {
  let that = event.target
  that.value = that.value.replace(/[^\d]/g, '') // 是否是数字，若是除数字之外的则替换为空
  if (type == '>zero') {
    console.log(that.value)
    console.log(typeof that.value)
    if (that.value == '0') {
      return ''
    } else {
      return that.value
    }
  } else {
    return that.value
  }
}

// 可以输入除开中文以外的字符
export function checkInputEnglish(event) {
  let that = event.target
  that.value = that.value.replace(/[\u4E00-\u9FA5]/g, '')
  return that.value
}
// 只允许输入a-zA-Z 英文大小写
export function checkInputEnglishB(event) {
  let value = event && event.target ? event.target.value : event
  // 只保留英文大小写字母
  value = value.replace(/[^a-zA-Z]/g, '')
  if (event && event.target) event.target.value = value
  return value
}
// 只允许输入a-zA-Z 英文大小写 和数字
export function checkInputEnglishNum(event) {
  let that = event.target
  const regex = /^[a-zA-Z0-9]+$/
  // 检查输入值是否符合正则表达式
  if (!regex.test(that.value)) {
    // 如果不符合，则清空输入或者提醒用户
    that.value = that.value.replace(/[^a-zA-Z0-9]/g, '')
    // 或者提示用户，例如：alert('请输入中文！');
  }
  return that.value
}
// 只允许输入中文
export function checkInputCN(event) {
  let value = event && event.target ? event.target.value : event
  // 只保留中文字符
  value = value.replace(/[^\u4e00-\u9fa5]/g, '')
  if (event && event.target) event.target.value = value
  return value
}

// 只允许输入中文+（） ()
export function checkInputCNB(event) {
  let that = event.target
  const regex = /^[\u4e00-\u9fa5（）()]+$/
  // 检查输入值是否符合正则表达式
  if (!regex.test(that.value)) {
    // 如果不符合，则清空输入或者提醒用户
    that.value = that.value.replace(/[^\u4e00-\u9fa5（）()]/g, '')
    // 或者提示用户，例如：alert('请输入中文！');
  }
  return that.value
}
// 只允许输入正数和负数（可带小数点，负号只能在首位）
export function checkInputNumber(event) {
  let value = event && event.target ? event.target.value : event
  // 只允许输入数字、负号和小数点
  value = value.replace(/[^\d\.\-]/g, '')
  // 只允许一个负号且只能在首位
  value = value.replace(/(?!^)-/g, '')
  if (value.indexOf('-') > 0) value = value.replace('-', '')
  // 只允许一个小数点
  value = value.replace(/\.{2,}/g, '.')
  value = value.replace('.', '$#$').replace(/\./g, '').replace('$#$', '.')
  // 小数点不能在首位
  if (value.startsWith('.')) value = value.substring(1)
  // 负号和小数点不能连在一起
  if (value.startsWith('-.')) value = '-'
  if (event && event.target) event.target.value = value
  return value
}

// 判断一个值存在且可以是 0
export function isValueZeroOrExists(value) {
  return value !== undefined && value !== null && !isNaN(value) && value === 0
}
// 根据结束时间限制开始时间
export function pickerOptionsStart(dateEnd) {
  return {
    disabledDate(time) {
      if (dateEnd) {
        // 如果结束时间不为空，则小于结束时间
        return new Date(dateEnd).getTime() < time.getTime()
      } else {
        // return time.getTime() > Date.now() // 开始时间不选时，结束时间最大值小于等于当天
      }
    },
  }
}

// 根据开始时间限制结束时间
export function pickerOptionsEnd(dateStart) {
  return {
    disabledDate(time) {
      if (dateStart) {
        // 如果开始时间不为空，则结束时间大于开始时间
        return new Date(dateStart).getTime() > time.getTime()
      } else {
        // return time.getTime() > Date.now() // 开始时间不选时，结束时间最大值小于等于当天
      }
    },
  }
}

//乘以100失去精度计算
export function multipliedByHundred(str) {
  let floatVal = parseFloat(str)
  if (isNaN(floatVal)) {
    return 0
  }
  floatVal = Math.round(str * 10000) / 100
  let strVal = floatVal.toString()
  let searchVal = strVal.indexOf('.')
  if (searchVal < 0) {
    searchVal = strVal.length
    strVal += '.'
  }
  while (strVal.length <= searchVal + 2) {
    strVal += '0'
  }
  return parseFloat(strVal)
}

// 除以100保留两位小数点
export function divideByHundred(str) {
  let floatVal = parseFloat(str)
  if (isNaN(floatVal)) {
    return 0
  }
  floatVal = Math.round(str * 100) / 10000
  let strVal = floatVal.toString()
  let searchVal = strVal.indexOf('.')
  if (searchVal < 0) {
    searchVal = strVal.length
    strVal += '.'
  }
  while (strVal.length <= searchVal + 2) {
    strVal += '0'
  }
  return parseFloat(strVal)
}

/**
 * Remove class from element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function removeClass(ele, cls) {
  if (hasClass(ele, cls)) {
    const reg = new RegExp('(\\s|^)' + cls + '(\\s|$)')
    ele.className = ele.className.replace(reg, ' ')
  }
}

/**
 * Check if an element has a class
 * @param {HTMLElement} elm
 * @param {string} cls
 * @returns {boolean}
 */
export function hasClass(ele, cls) {
  return !!ele.className.match(new RegExp('(\\s|^)' + cls + '(\\s|$)'))
}

/**
 * Add class to element
 * @param {HTMLElement} elm
 * @param {string} cls
 */
export function addClass(ele, cls) {
  if (!hasClass(ele, cls)) ele.className += ' ' + cls
}

export function makeMap(str, expectsLowerCase) {
  const map = Object.create(null)
  const list = str.split(',')
  for (let i = 0; i < list.length; i++) {
    map[list[i]] = true
  }
  return expectsLowerCase ? (val) => map[val.toLowerCase()] : (val) => map[val]
}

export function calculateTimeDifference(date1, date2) {
  // 将日期转换为毫秒
  const timestamp1 = Date.parse(date1)
  const timestamp2 = Date.parse(date2)

  // 计算差值
  const difference = timestamp2 - timestamp1

  // 将差值转换为时分秒格式
  // const seconds = Math.floor((difference / 1000) % 60)
  // const minutes = Math.floor((difference / (1000 * 60)) % 60)
  // const hours = Math.floor((difference / (1000 * 60 * 60)) % 24)
  const days = Math.floor(difference / (1000 * 60 * 60 * 24))

  // 返回一个对象包含天数和时分秒
  return days
  // return {
  //   days,
  //   hours,
  //   minutes,
  //   seconds,
  // }
}

export const exportDefault = 'export default '

export const beautifierConf = {
  html: {
    indent_size: '2',
    indent_char: ' ',
    max_preserve_newlines: '-1',
    preserve_newlines: false,
    keep_array_indentation: false,
    break_chained_methods: false,
    indent_scripts: 'separate',
    brace_style: 'end-expand',
    space_before_conditional: true,
    unescape_strings: false,
    jslint_happy: false,
    end_with_newline: true,
    wrap_line_length: '110',
    indent_inner_html: true,
    comma_first: false,
    e4x: true,
    indent_empty_lines: true,
  },
  js: {
    indent_size: '2',
    indent_char: ' ',
    max_preserve_newlines: '-1',
    preserve_newlines: false,
    keep_array_indentation: false,
    break_chained_methods: false,
    indent_scripts: 'normal',
    brace_style: 'end-expand',
    space_before_conditional: true,
    unescape_strings: false,
    jslint_happy: true,
    end_with_newline: true,
    wrap_line_length: '110',
    indent_inner_html: true,
    comma_first: false,
    e4x: true,
    indent_empty_lines: true,
  },
}
